import { convertHtmlToText } from '@/utils/util';

export default {
	methods: {
		getShopDetailContents(item) {
			let message = '';
			message += `주소 : ${item.ar_addr1} ${item.ar_addr2}\n\n`;
			message += `상세 안내 : ${convertHtmlToText(item.ar_content)}\n\n`;
			message += `주차 여부 : ${item.ar_parking}\n\n`;
			if (item.ar_category !== '1') {
				// 일반 지점
				message += `영업 시간 : 평일 - ${item.ar_time1} / 토,일 - ${item.ar_time2}`;
				if (item.ar_id === '59') {
					message += ` / 휴무일 - 매월 둘째, 넷째 일요일 휴무`;
				}
				message += `\n\n`;
			} else {
				// 백화점 지점
				message += `영업 시간 : 평일(월-목) - ${item.ar_time1} / 주말(금,토,일).공휴일 - ${item.ar_time2}\n`;
				message += `백화점 상황에 따라 연장근무 가능\n`;
			}
			message += `전화 : ${item.shop_tel}`;
			return message;
		},
	},
};
